import { Article, BookOpenText, EnvelopeSimple } from "@phosphor-icons/react";
import { WordCount } from "./Inputs";

const textareaCls = "neu-input w-full mt-6 p-5 text-base leading-relaxed";

export const EmailTask = ({ task, value, onChange }) => (
  <div>
    <div className="text-xs font-mono-fig text-muted-foreground">Writing · {task.title}</div>
    <p className="mt-2 text-sm text-foreground/80 max-w-3xl" data-testid="test-question-prompt">{task.instructions}</p>
    <div className="mt-6 neu-inset rounded-2xl p-6" data-testid="test-email-card">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <EnvelopeSimple size={16} weight="duotone" className="text-indigo" />
        From: <span className="text-foreground font-medium">{task.from}</span>
        <span className="opacity-50">·</span> Subject: <span className="text-foreground font-medium">{task.subject}</span>
      </div>
      <div className="mt-5 space-y-4">
        {task.body.map((b, i) => (
          <div key={i} className="flex flex-col sm:flex-row sm:items-start gap-3">
            <p className="flex-1 text-[15px] leading-relaxed text-foreground/85">{b.text}</p>
            <span className="neu-btn-primary self-start rounded-xl px-3 py-1.5 text-xs font-bold whitespace-nowrap" data-testid={`test-email-note-${i}`}>
              {i + 1}. {b.note}
            </span>
          </div>
        ))}
      </div>
    </div>
    <textarea
      data-testid="test-writing-email-textarea"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      rows={10}
      maxLength={5000}
      placeholder="Hi Jamie, …"
      className={textareaCls}
    />
    <WordCount text={value} min={task.min_words} target={task.target_words} testId="test-writing-email-wordcount" />
  </div>
);

const ICONS = { article: Article, story: BookOpenText };

export const ChoiceTask = ({ choices, choice, onChoice, value, onChange }) => {
  const task = choices.find((c) => c.id === choice);
  return (
    <div>
      <div className="text-xs font-mono-fig text-muted-foreground">Writing · Task 2 — choose ONE</div>
      <div className="mt-4 grid sm:grid-cols-2 gap-3">
        {choices.map((c) => {
          const Icon = ICONS[c.id];
          const on = c.id === choice;
          return (
            <button
              key={c.id}
              onClick={() => onChoice(c.id)}
              data-testid={`test-writing-choice-${c.id}`}
              className={`flex items-center gap-3 p-4 text-left ${on ? "neu-sm is-selected" : "neu-sm hover:bg-foreground/[0.04]"}`}
            >
              <span className={`w-10 h-10 rounded-full flex items-center justify-center ${on ? "neu-btn-primary" : "neu-sm text-indigo"}`}>
                <Icon size={18} weight="duotone" />
              </span>
              <span className="font-bold text-foreground">{c.title.split("· ")[1]}</span>
            </button>
          );
        })}
      </div>
      <p className="mt-6 text-sm text-foreground/80" data-testid="test-question-prompt">{task.instructions}</p>
      {task.notice && (
        <div className="mt-4 neu-inset rounded-2xl p-6" data-testid="test-writing-notice">
          <div className="overline">{task.notice_title}</div>
          <p className="mt-3 whitespace-pre-line leading-relaxed text-foreground/90">{task.notice}</p>
        </div>
      )}
      {task.opening && (
        <div className="mt-4 neu-inset rounded-2xl p-6 italic text-lg text-foreground" data-testid="test-writing-opening">
          “{task.opening}”
        </div>
      )}
      <textarea
        data-testid="test-writing-extended-textarea"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={10}
      maxLength={5000}
        placeholder={task.opening ? "Continue the story…" : "Write your article…"}
        className={textareaCls}
      />
      <WordCount text={value} min={task.min_words} target={task.target_words} testId="test-writing-extended-wordcount" />
    </div>
  );
};
